const requiredAuditPhotos = ['Dash VIN', 'Driver Side Front', 'Passenger Side Rear']

export default requiredAuditPhotos
